import defaultApi from '@/utils/request';

export default {
  // S40W2001 學生居住狀況調查登錄
  S40W2001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S40/S40W2001_Load',
      params,
    });
  },
  S40W2001_getCityZip(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S40/S40W2001_getCityZip',
      params,
    });
  },
  S40W2001_getClsmate(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S40/S40W2001_getClsmate',
      params,
    });
  },
  S40W2001_SaveApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S40/S40W2001_SaveApply',
      data,
    });
  },
  // S40W4001 取得限定身份資格
  Get_LiveAuth(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S40/S40W4001_Get_LiveAuth',
      params,
    });
  },

  // 取得居住狀況清單
  Get_LiveStatus(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S40/S40W4001_Get_LiveStatus',
      params,
    });
  },
  // 取得居住狀況清單2
  Get_LiveStatus2(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S40/S40W4001_Get_LiveStatus2',
      params,
    });
  },
  Get_LiveStatusDetail(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S40/S40W4001_Get_LiveStatusDetail',
      params,
    });
  },
  S40W4001_Get_PDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S40/S40W4001_Get_PDF',
      responseType: 'blob',
      params,
    });
  },

  // ========================================================================================================
  // S40W4002 特教生查詢
  S40W4002_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S40/S40W4002_Load',
      params,
    });
  },
  S40W4002_GetRecorddDTByStu(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S40/S40W4002_GetRecorddDTByStu',
      params,
    });
  },
  S40W4002_GetMemoData(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S40/S40W4002_GetMemoData',
      params,
    });
  },
  S40W4002_Get_ClsList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S40/S40W4002_Get_ClsList',
      params,
    });
  },
  S40W4002_Get_SelcodeList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S40/S40W4002_Get_SelcodeList',
      params,
    });
  },
  // ========================================================================================================

};
